import { observable } from "mobx";
import TradingPlaceType from "./tradingPlaceType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class TradingPlaceResponse {
  /**
   * Trading place ID.
   */
  id!: string;

  /**
   * Trading place name.
   */
  @observable
  name!: string;

  @observable
  type!: TradingPlaceType;

  /**
   * Indicating whether the trading place is visible and purchase is allowed.
   */
  @observable
  isAvailable!: boolean;

  /**
   * Location latitude.
   */
  @observable
  latitude: number;

  /**
   * Location longitude.
   */
  @observable
  longitude: number;
}
